import { observer } from 'mobx-react-lite'
import { DocumentPickerDialog } from '../DocumentPickerDialog'
import {
  DocumentPickerItem,
  DocumentPickerItemSkeleton,
} from '../DocumentPickerDialog'
import { DocumentThumbnail } from '@/features/docs/components/DocumentThumbnail'
import type { DocumentLinkingViewModel } from '@/features/docs/components/LinkDocumentsDialog/DocumentLinkingViewModel'
import { SkeletonListInfiniteScrollTrigger } from '@/components/SkeletonListInfiniteScrollTrigger'

export interface LinkDocumentsDialogProps {
  vm: DocumentLinkingViewModel
  'aria-label'?: string

  /**
   * Placeholder text for the search input.
   **/
  searchPlaceholder?: string
  testId?: string
  doneButtonTestId?: string
}

/**
 * Dialog for linking documents.
 */
export const LinkDocumentsDialog = observer(function LinkDocumentsDialog({
  vm,
  searchPlaceholder = 'Search documents to link',
  'aria-label': ariaLabel = 'Link existing documents',
  testId,
  doneButtonTestId,
}: LinkDocumentsDialogProps) {
  return (
    <DocumentPickerDialog
      isOpen={vm.modal.showing}
      onClose={vm.modal.close}
      searchText={vm.documentsList.searchText.value}
      onSearchTextChange={(text) => vm.documentsList.searchText.change(text)}
      searchPlaceholder={searchPlaceholder}
      aria-label={ariaLabel}
      testId={testId}
      doneButtonTestId={doneButtonTestId}
    >
      {vm.documentsList.filteredDocuments.map((docVm) => (
        <DocumentPickerItem
          key={docVm.doc.id}
          title={docVm.doc.title}
          description={docVm.displayTypeName}
          onAction={docVm.action}
          isPending={docVm.action.pending}
          testId={`document-picker-item-${docVm.doc.title}`}
          thumbnail={
            <DocumentThumbnail
              name={docVm.displayTypeName}
              imageUrl={docVm.doc.typeImageUrl}
            />
          }
        />
      ))}

      <SkeletonListInfiniteScrollTrigger
        scroller={vm.documentsList.scroller}
        maxSkeletons={4}
      >
        <DocumentPickerItemSkeleton />
      </SkeletonListInfiniteScrollTrigger>
    </DocumentPickerDialog>
  )
})
